/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S42_Item_3Inputs */

const es_tyc_obligations_s42_item_3 = /** @type {(inputs: Tyc_Obligations_S42_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recolectar o almacenar Datos Ingestados o Externos con fines no relacionados con el Servicio autorizado.`)
};

const en_tyc_obligations_s42_item_3 = /** @type {(inputs: Tyc_Obligations_S42_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collect or store Ingested or External Data for purposes unrelated to the authorized Service.`)
};

/**
* | output |
* | --- |
* | "Collect or store Ingested or External Data for purposes unrelated to the authorized Service." |
*
* @param {Tyc_Obligations_S42_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s42_item_3 = /** @type {((inputs?: Tyc_Obligations_S42_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S42_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s42_item_3(inputs)
	return en_tyc_obligations_s42_item_3(inputs)
});
export { tyc_obligations_s42_item_3 as "tyc.obligations.s42_item_3" }